<ngx-spinner 
    size = "medium" 
    bdColor = "rgba(0, 0, 0, 0.8)" 
    color = "#fff"
    type = "ball-clip-rotate la-3x" 
    [fullScreen] = "true">
    <p style="color: white" > Loading... </p>
</ngx-spinner>